import SupportForm from "../../../components/portal/user-support/SupportForm";

const UsersSuppport = () => {
  return (
    <>
      <SupportForm />
    </>
  );
};
export default UsersSuppport;
